import { TextField } from '@material-ui/core';
import PropTypes from 'prop-types';
import { FC } from 'react';

interface BasicTextFieldProps {
  label: string;
  index: string;
  value: string;
  onChange: (event: any) => void;
}

export const BasicTextField: FC<BasicTextFieldProps> = (props) => {
  const { label, index, value, onChange } = props;
  return (
    <TextField
      id="outlined-basic"
      label={label}
      size="small"
      variant="outlined"
      name={index}
      value={value || ''}
      sx={{ m: 1, width: '100%' }}
      onChange={onChange}
    />
  );
};

BasicTextField.propTypes = {
  label: PropTypes.string,
  index: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func
};
